/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./learn.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./learn.component";
import * as i3 from "../data/process.service";
import * as i4 from "../util/location.service";
var styles_LearnComponent = [i0.styles];
var RenderType_LearnComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_LearnComponent, data: {} });
export { RenderType_LearnComponent as RenderType_LearnComponent };
export function View_LearnComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [["class", "p-3"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" Redirecting to the learning center\n"]))], null, null); }
export function View_LearnComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-learn", [], null, null, null, View_LearnComponent_0, RenderType_LearnComponent)), i1.ɵdid(1, 114688, null, 0, i2.LearnComponent, [i3.ProcessService, i4.LocationService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LearnComponentNgFactory = i1.ɵccf("app-learn", i2.LearnComponent, View_LearnComponent_Host_0, {}, {}, []);
export { LearnComponentNgFactory as LearnComponentNgFactory };
